export default IconDatabaseX => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-database-x" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3" />
  <path d="M4 6v6c0 1.657 3.582 3 8 3c.537 0 1.062 -.02 1.57 -.058" />
  <path d="M20 13.5v-7.5" />
  <path d="M4 12v6c0 1.657 3.582 3 8 3c.384 0 .762 -.01 1.132 -.03" />
  <path d="M22 22l-5 -5" />
  <path d="M17 22l5 -5" />
</svg>`;